import { Getters } from '@/shared/core/store/getters';
import { Mutations } from '@/shared/core/store/mutations';
import { Actions } from '@/shared/core/store/actions';
import { BalanceAlertConfiguration } from '../model/BalanceAlertConfiguration';
import { BalanceAlertState } from '../model/BalanceAlertState';
import { balanceAlertService } from '../services/balance-alert.service';

const balanceAlertConfigState: BalanceAlertState = {
  balanceAlertConfiguration: null,
};

export const balanceAlert = {
  namespaced: true,
  state: balanceAlertConfigState,
  mutations: {
    [Mutations.SET_BALANCE_ALERT_CONFIGURATION]: (
      state: BalanceAlertState,
      balanceAlertConfiguration: BalanceAlertConfiguration,
    ) => {
      state.balanceAlertConfiguration = balanceAlertConfiguration;
    },
  },
  getters: {
    [Getters.BALANCE_ALERT_CONFIGURATION]: (
      state: BalanceAlertState,
    ): BalanceAlertConfiguration | null => state.balanceAlertConfiguration,
  },
  actions: {
    [Actions.SET_BALANCE_ALERT_CONFIGURATION]: async (
      // eslint-disable-next-line @typescript-eslint/ban-types
      { commit }: { commit: Function },
      customerId: string,
    ) => {
      commit(
        Mutations.SET_BALANCE_ALERT_CONFIGURATION,
        (await balanceAlertService.getBalanceAlertConfiguration(customerId)) || null,
      );
    },
  },
};
